var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tk-btn',{staticClass:"base-btn",attrs:{"outline":"","dark":"","color":"white","large":"","type":_vm.type,"loading":_vm.loading}},[_c('span',{staticClass:"caption font-weight-medium"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }